import { render } from "./turmaAll.vue?vue&type=template&id=5e0c68c9&scoped=true"
import script from "./turmaAll.vue?vue&type=script&lang=js"
export * from "./turmaAll.vue?vue&type=script&lang=js"

import "./turmaAll.vue?vue&type=style&index=0&id=5e0c68c9&lang=scss&scoped=true"
import "./turmaAll.vue?vue&type=style&index=1&id=5e0c68c9&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0c68c9"]])

export default __exports__